import { render, staticRenderFns } from "./Infographic4.vue?vue&type=template&id=4250640a&scoped=true&"
import script from "./Infographic4.vue?vue&type=script&lang=js&"
export * from "./Infographic4.vue?vue&type=script&lang=js&"
import style0 from "./Infographic4.vue?vue&type=style&index=0&id=4250640a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4250640a",
  null
  
)

export default component.exports